import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	FormControlLabel
} from "@mui/material";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import Util from "../../validation/index";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import { getWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import { adminGetRiskRuleList } from "../../redux/actions/adminGetRiskRuleListAction";
import { adminAddRiskRule } from "../../redux/actions/adminAddRiskRuleAction";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SearchIcon from "@mui/icons-material/Search";
import val from "../../getThemeDetails"
const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

function AdminRiskRuleManagement() {
	// const [ruleIDSearch, setRuleIDSearch] = useState("");
	// const [riskGroupSearch, setRiskGroupSearch] = useState("");
	// const [statusSearch, setStatusSearch] = useState("");
	const [walletOwnerId, setWalletOwnerId] = useState("");
	const [page, setPage] = useState(0);
	const [editOpen, setEditOpen] = React.useState(false);
	const [viewOpen, setViewOpen] = React.useState(false);
	const [addOpen, setAddOpen] = React.useState(false);
	const [addMapping, setAddMapping] = useState(false)
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [isLoading, setIsLoading] = useState(false);

	const [getWalletOwnerIdStatus, setGetWalletOwnerIdStatus] = useState(false);
	const [getWalletOwnerIdResArray, setGetWalletOwnerIdResArray] = useState([]);

	const [getRiskRuleListStatus, setGetRiskRuleListStatus] = useState(false);
	const [getRiskRuleListArray, setRiskRuleListArray] = useState([]);

	const [addOrUpdateRiskRuleStatus, setAddOrUpdateRiskRuleStatus] =
		useState(false);
	const [addOrUpdateRiskRuleArray, setAddOrUpdateRiskRuleArray] = useState("");
	const [notificationOpen, setNotificationOpen] = React.useState(false);

	const view = "view";
	const edit = "edit";

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;
	const classes = useStyles();
	const dispatch = useDispatch();

	const [user, setUser] = useState({
		ruleId: "",
		ruleName: "",
		description: "",
		riskGroup: "",
		score: "",
		count: "",
		refundTime: "",
		actionPhase: "",
		status: ""
	});

	const { ruleId, ruleName, description, riskGroup, count, refundTime, actionPhase, score, status } = user;

	const [search, setSearch] = useState({
		ruleIDSearch: "",
		riskGroupSearch: "",
		statusSearch: ""
	});

	const { ruleIDSearch, riskGroupSearch, statusSearch } = search;

	const onInputChange = ({ target: { name, value } }, type) => {
		// setUser({ ...user, [e.target.name]: e.target.value });

		const obj = {
			...user
		};

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else {
			// obj[name] = value.trim()
			obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
		}
		setUser(obj);
	};

	const handleChange = ({ target: { name, value } }, type) => {
		// setUser({ ...user, [e.target.name]: e.target.value });

		const obj = {
			...search
		};

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else {
			// obj[name] = value.trim()
			obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
		}
		setSearch(obj);
	};

	const getWalletOwnerIdRes = useSelector(
		({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList
	);

	const getRiskRuleListRes = useSelector(
		({ adminGetRiskRuleList }) => adminGetRiskRuleList
	);

	const addOrUpdateRiskRuleRes = useSelector(
		({ adminAddRiskRule }) => adminAddRiskRule
	);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getRiskRuleListReq();
			getWalletOwnerIdAndNameListReq();
		}
	}, [regenerateTokenRes.data.AuthToken]);

	const getWalletOwnerIdAndNameListReq = () => {
		setGetWalletOwnerIdStatus(true);
		dispatch(
			getWalletOwnerIdAndNameList(
				{
					loginDetails: {
						adminId: val.adminIDS
						// adminId: "2"
					}
				},
				authToken
			)
		);
	};

	const getWalletOwnerIdStatusFunc = () => {
		if (getWalletOwnerIdStatus) {
			if (getWalletOwnerIdRes.data.status == "success") {
				setGetWalletOwnerIdResArray(
					[].concat(getWalletOwnerIdRes.data.ownerList)
				);
			}
			if (getWalletOwnerIdRes.data.status == "failed") {
				setGetWalletOwnerIdResArray(getWalletOwnerIdRes.data);
				if (
					getWalletOwnerIdRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getWalletOwnerIdRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getWalletOwnerIdStatusFunc();
	}, [getWalletOwnerIdRes.data.status]);

	// const handleChange = ({ target: { name, value } }) => {
	// 	if (name === "RuleID") {
	// 		setRuleIDSearch(value);
	// 	}
	// 	if (name === "RiskGroup") {
	// 		setRiskGroupSearch(value == "All" ? "" : value);
	// 	}
	// 	if (name === "Status") {
	// 		setStatusSearch(value == "All" ? "" : value);
	// 	}
	// };

	const getRiskRuleListReq = () => {
		setIsLoading(true);
		setGetRiskRuleListStatus(true);
		let req = {
			actionCustomerMasterRequestVO: {
				ruleId: ruleIDSearch,
				riskGroup: riskGroupSearch == "All" ? "" : riskGroupSearch,
				ruleStatus: statusSearch == "All" ? "" : statusSearch
			}
		};
		dispatch(adminGetRiskRuleList(req, authToken));
	};

	const getRiskRuleListFunc = () => {
		if (getRiskRuleListStatus) {
			setIsLoading(false);
			if (getRiskRuleListRes.data.status == "success") {
				setRiskRuleListArray([].concat(getRiskRuleListRes.data.riskRuleList));
			}
			if (getRiskRuleListRes.data.status == "failed") {
				setRiskRuleListArray(getRiskRuleListRes.data);
				NotificationPopups(
					"error",
					"Failed",
					getRiskRuleListRes.data.description
				);
				if (
					getRiskRuleListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getRiskRuleListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getRiskRuleListRes.data.status == "NOT FOUND") {
				setRiskRuleListArray(getRiskRuleListRes.data);
				NotificationPopups(
					"error",
					"Failed",
					getRiskRuleListRes.data.description
				);
			}
		}
	};

	useEffect(() => {
		getRiskRuleListFunc();
	}, [getRiskRuleListRes.data.status]);

	const addOrUpdateRiskRuleReq = () => {
		setAddOpen(false);
		setEditOpen(false);
		setAddOrUpdateRiskRuleStatus(true);
		let req = {
			ruleId: ruleId,
			ruleName: ruleName,
			riskGroup: riskGroup,
			isActive: status,
			ruleDescription: description,
			count: count,
			refundTime: refundTime,
			actionPhase: actionPhase,
			riskScore: score
		};
		dispatch(adminAddRiskRule(req, authToken));
	};

	const addOrUpdateRiskRuleFunc = () => {
		if (addOrUpdateRiskRuleStatus) {
			if (addOrUpdateRiskRuleRes.data.status == "success") {
				setAddOrUpdateRiskRuleArray(addOrUpdateRiskRuleRes.data);
				setNotificationOpen(true);
				getRiskRuleListReq();
				setUser({
					ruleId: "",
					ruleName: "",
					description: "",
					riskGroup: "",
					score: "",
					status: ""
				});
			}
			if (addOrUpdateRiskRuleRes.data.status == "failed") {
				setAddOrUpdateRiskRuleArray(addOrUpdateRiskRuleRes.data);
				setNotificationOpen(true);
				if (
					addOrUpdateRiskRuleRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					addOrUpdateRiskRuleRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		addOrUpdateRiskRuleFunc();
	}, [addOrUpdateRiskRuleRes.data.status]);

	const setData = (row, fs) => {
		console.log(row, "////////////////////////////");
		if (fs == "view") {
			setViewOpen(true);
		}
		if (fs == "edit") {
			setEditOpen(true);
		}
		setUser({
			ruleId: row.ruleId,
			ruleName: row.ruleName,
			description: row.ruleDescription,
			riskGroup: row.riskGroup,
			score: row.priority,
			status: row.isActive
		});
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleClose = () => {
		setEditOpen(false);
		setViewOpen(false);
		setAddOpen(false);
		setAddMapping(false)
		setUser({
			ruleId: "",
			ruleName: "",
			description: "",
			riskGroup: "",
			score: "",
			status: ""
		});
	};

	const addRiskRule = () => {
		setAddOpen(true);
	};

	const addRiskRuleMapping = () => {
		setAddMapping(true);
	};

	const disabledBtn = () => {
		console.log(
			!(ruleId !== "" && ruleName !== "" && description !== ""),
			"//////////"
		);
		return !(ruleId && ruleName && description);
	};

	return (
		<>
			<Layout>
				<Card>
					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1rem",
							marginLeft: "1rem",
							gap: "10px",
							textAlign: "center"
						}}
					// style={{ padding: "25px", gap: "20px" }}
					>
						{/* <Grid item xs={12} md={4} sm={3} lg={4}></Grid> */}
						<Grid item xs={12} md={3} sm={3} lg={3}>
							{/* <Button
								variant="contained"
								style={{ backgroundColor: "#00b9f5", color: "white" }}
								size="small"
								onClick={() => addRiskRule()}
							>
								Add New Risk Rule
							</Button> */}
							<CustomButton
								style={{
									padding: "8px",
									marginLeft: "15px"
								}}
								onClick={() => addRiskRule()}
							// onClick={getgateWayTransactionListReq}
							>
								Add New Risk Rule
							</CustomButton>
						</Grid>
						<Grid item xs={12} md={3} sm={3} lg={2}>
							<NavLink to="/index/RiskRuleMapping">
								{/* <Button
									variant="contained"
									style={{ backgroundColor: "#00b9f5", color: "white" }}
									size="small"
								>
									Risk Rule Mapping
								</Button> */}
								<CustomButton
									style={{
										padding: "8px",
										marginLeft: "15px"
									}}

								// onClick={getgateWayTransactionListReq}
								>
									Risk Rule Mapping
								</CustomButton>

							</NavLink>
						</Grid>
						<Grid item xs={12} md={3} sm={3} lg={3}>
							<NavLink to="/index/adminAddRiskRuleMapping">
								{/* <Button
									variant="contained"
									style={{ backgroundColor: "#00b9f5", color: "white" }}
									size="small"
								>
									add risk rule mapping
								</Button> */}
								<CustomButton
									style={{
										padding: "8px",
										marginLeft: "15px"
									}}

								// onClick={getgateWayTransactionListReq}
								>
									add risk rule mapping
								</CustomButton>

							</NavLink>
						</Grid>
					</Grid>

					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								size="small"
								color="primary"
								type="text"
								label="Rule ID"
								fullWidth={true}
								name="ruleIDSearch"
								value={ruleIDSearch}
								onChange={(e) => handleChange(e, "number")}
							></TextField>
						</Grid>
						<Grid xs={12} item sm={12} md={4} lg={4}>
							<TextField
								select
								size="small"
								color="primary"
								variant="standard"
								type="text"
								label="Risk Group"
								fullWidth={true}
								name="riskGroupSearch"
								defaultValue={riskGroupSearch || "All"}
								onChange={handleChange}
							>
								<MenuItem value="All">Select Risk Group</MenuItem>
								<MenuItem value="Redeem">Redeem</MenuItem>
								<MenuItem value="Purchase">Purchase</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								select
								size="small"
								color="primary"
								variant="standard"

								type="text"
								label="Status"
								fullWidth={true}
								name="statusSearch"
								defaultValue={statusSearch || "All"}
								onChange={handleChange}
							>
								<MenuItem value="All">Select Status</MenuItem>
								<MenuItem value="Y">Enable</MenuItem>
								<MenuItem value="N">Disable</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							{/* <Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white",
									marginTop: "9px"
								}}
								endIcon={<AiOutlineSearch />}
								variant="contained"
								onClick={getRiskRuleListReq}
							>
								Search
							</Button> */}
							<CustomButton
								style={{
									padding: "8px",
									marginLeft: "15px"
								}}
								onClick={getRiskRuleListReq}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getRiskRuleListArray.length == undefined ||
					getRiskRuleListArray.status == "NOT FOUND" ||
					!getRiskRuleListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"

								>
									Report Table
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"
								>
									Report Tableeeeeeee
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Rule ID
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Rule Name
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Risk Group
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Count
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Refund Time
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action Phase
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Status
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getRiskRuleListArray &&
											[]
												.concat(getRiskRuleListArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow>
														<TableCell align="center">{row.ruleId}</TableCell>
														<TableCell align="center">{row.ruleName}</TableCell>
														<TableCell align="center">
															{row.riskGroup}
														</TableCell>
														<TableCell align="center">
															{row.count}
														</TableCell>
														<TableCell align="center">
															{row.refundTime}
														</TableCell>
														<TableCell align="center">
															{row.actionPhase}
														</TableCell>
														<TableCell align="center">
															{row.isActive == "Y" ? "Enable" : "Disable"}
														</TableCell>
														<TableCell align="center">
															<CustomButton
																style={{
																	padding: "8px"
																}}
																onClick={() => setData(row, view)}
															>
																<VisibilityIcon style={{ color: "#fff" }} />
															</CustomButton>
															<CustomButton
																style={{
																	padding: "8px"
																}}
																onClick={() => setData(row, edit)}
															>
																<EditIcon style={{ color: "#fff" }} />
															</CustomButton>
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getRiskRuleListArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}
				<div>
					<Dialog open={editOpen} onClose={handleClose}>
						<DialogTitle>Edit Risk Rule</DialogTitle>
						<DialogContent>
							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								variant="standard"
								label="Rule Name"
								fullWidth={true}
								name="ruleName"
								value={ruleName}
								onChange={(e) => onInputChange(e, "alphabet")}
							></TextField>

							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								variant="standard"

								type="text"
								label="Description"
								fullWidth={true}
								name="description"
								value={description}
								onChange={(e) => onInputChange(e, "both")}
							></TextField>

							<TextField
								required
								style={{ marginTop: "10px" }}
								select
								size="small"
								color="primary"
								variant="standard"

								type="text"
								label="Risk Group"
								fullWidth={true}
								name="riskGroup"
								defaultValue={riskGroup || "Select Risk Group"}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem value="Select Risk Group">Select Risk Group</MenuItem>
								<MenuItem value="Redeem">Redeem</MenuItem>
								<MenuItem value="Purchase">Purchase</MenuItem>
							</TextField>

							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								variant="standard"

								type="text"
								label="Score"
								fullWidth={true}
								name="score"
								value={score}
								onChange={(e) => onInputChange(e, "number")}
							></TextField>

							<TextField
								style={{ marginTop: "10px" }}
								select
								size="small"
								color="primary"
								variant="standard"

								type="text"
								label="Status"
								fullWidth={true}
								name="status"
								defaultValue={status || "Select Status"}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem value="Select Status">Select Status</MenuItem>
								<MenuItem value="Y">Enable</MenuItem>
								<MenuItem value="N">Disable</MenuItem>
							</TextField>
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<Button
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</Button>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={addOrUpdateRiskRuleReq}
							>
								Save
							</Button>
						</DialogActions>
					</Dialog>
				</div>
				<div>
					<Dialog open={viewOpen} onClose={handleClose}>
						<DialogTitle>View Risk Rule</DialogTitle>
						<DialogContent>
							<TextField
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Rule Name"
								variant="standard"
								fullWidth={true}
								name="ruleName"
								value={ruleName}
							></TextField>
							<TextField
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								variant="standard"

								label="Description"
								fullWidth={true}
								name="description"
								value={description}
							></TextField>

							<TextField
								disabled
								style={{ marginTop: "10px" }}
								select
								size="small"
								color="primary"
								type="text"
								variant="standard"

								label="Risk Group"
								fullWidth={true}
								name="riskGroup"
								defaultValue={riskGroup || "Select Risk Group"}
							>
								<MenuItem value="Select Risk Group">Select Risk Group</MenuItem>
								<MenuItem value="Redeem">Redeem</MenuItem>
								<MenuItem value="Purchase">Purchase</MenuItem>
							</TextField>

							<TextField
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Score"
								variant="standard"

								fullWidth={true}
								name="score"
								value={score}
							></TextField>

							<TextField
								disabled
								style={{ marginTop: "10px" }}
								select
								size="small"
								color="primary"
								variant="standard"

								type="text"
								label="Status"
								fullWidth={true}
								name="status"
								defaultValue={status || "Select Status"}
							>
								<MenuItem value="Select Status">Select Status</MenuItem>
								<MenuItem value="Y">Enable</MenuItem>
								<MenuItem value="N">Disable</MenuItem>
							</TextField>
						</DialogContent>
						<DialogActions>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Close
							</Button>
						</DialogActions>
					</Dialog>
				</div>
				<div>
					<Dialog open={addOpen} onClose={handleClose}>
						<DialogTitle style={{ minWidth: "600px" }}>
							Add Risk Rule
						</DialogTitle>
						<DialogContent>
							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Rule Name"
								fullWidth={true}
								name="ruleName"
								value={ruleName}
								variant="standard"
								onChange={(e) => onInputChange(e, "alphabet")}
							></TextField>

							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Description"
								fullWidth={true}
								name="description"
								value={description || ""}
								variant="standard"

								onChange={(e) => onInputChange(e)}
							></TextField>

							<TextField
								required
								style={{ marginTop: "10px" }}
								select
								size="small"
								color="primary"
								type="text"
								label="Risk Group"
								variant="standard"
								fullWidth={true}
								name="riskGroup"
								defaultValue={"Select Risk Group" || riskGroup}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem value="Select Risk Group">Select Risk Group</MenuItem>
								<MenuItem value="Redeem">Redeem</MenuItem>
								<MenuItem value="Purchase">Purchase</MenuItem>
							</TextField>

							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Score"
								fullWidth={true}
								name="score"
								value={score || ""}
								variant="standard"

								onChange={(e) => onInputChange(e, "number")}
							></TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="count"
								fullWidth={true}
								name="count"
								value={count || ""}
								variant="standard"

								onChange={(e) => onInputChange(e, "number")}
							></TextField>

							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="refundTime"
								fullWidth={true}
								name="refundTime"
								value={refundTime || ""}
								variant="standard"

								onChange={(e) => onInputChange(e, "number")}
							></TextField>

							<TextField
								style={{ marginTop: "10px" }}
								select
								size="small"
								color="primary"
								type="text"
								variant="standard"

								label="action Phase"
								fullWidth={true}
								name="actionPhase"
								defaultValue={actionPhase || "Select Action Phase"}
							>
								<MenuItem value="Select Action Phase">Select Action Phase</MenuItem>
								<MenuItem value="PRE">PRE</MenuItem>
								<MenuItem value="POST">POST</MenuItem>
							</TextField>

							<TextField
								required
								style={{ marginTop: "10px" }}
								select
								size="small"
								color="primary"
								type="text"
								label="Status"
								fullWidth={true}
								name="status"
								variant="standard"

								defaultValue={"Select Status" || status}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem value="Select Status">Select Status</MenuItem>
								<MenuItem value="Y">Enable</MenuItem>
								<MenuItem value="N">Disable</MenuItem>
							</TextField>
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<Button
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</Button>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								// disabled={disabledBtn()}
								variant="contained"
								onClick={addOrUpdateRiskRuleReq}
							>
								Save
							</Button>
						</DialogActions>
					</Dialog>
				</div>
				<div>
					<Dialog open={addMapping} onClose={handleClose}>
						<DialogTitle style={{ minWidth: "600px" }}>
							Add Risk Rule
						</DialogTitle>
						<DialogContent>
							<TextField
								select
								required
								size="small"
								color="primary"
								type="text"
								label="Owner ID"
								fullWidth={true}
								name="walletOwnerId"
								// value={walletOwnerId || ""}
								defaultValue={"Select Owner Id" || walletOwnerId}
								onChange={handleChange}
							>
								<MenuItem value="Select Owner Id" selected="Select Owner Id">
									Select Owner Id
								</MenuItem>
								{getWalletOwnerIdRes.data.ownerList &&
									getWalletOwnerIdResArray.map((x) => (
										<MenuItem value={x.split("-")[0]}>{x}</MenuItem>
									))}
							</TextField>
							<TextField
								select
								required
								size="small"
								color="primary"
								type="text"
								label="Owner ID"
								fullWidth={true}
								name="walletOwnerId"
								// value={walletOwnerId || ""}
								defaultValue={"Select Owner Id" || walletOwnerId}
								onChange={handleChange}
							>
								<MenuItem value="Select Owner Id" selected="Select Owner Id">
									Select Owner Id
								</MenuItem>
								{getRiskRuleListRes.data.riskRuleList &&
									getRiskRuleListArray.map((x) => (
										<MenuItem value={x.ruleName}>{x.ruleName}</MenuItem>
									))}
							</TextField>
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<Button
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</Button>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								// disabled={disabledBtn()}
								variant="contained"
								onClick={addOrUpdateRiskRuleReq}
							>
								Save
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			</Layout>

			{addOrUpdateRiskRuleArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addOrUpdateRiskRuleArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addOrUpdateRiskRuleArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addOrUpdateRiskRuleArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
}

export default AdminRiskRuleManagement;
